import React from 'react';
import PropTypes from 'prop-types';
import * as mdIcons from 'react-icons/md';
import {
  HiOutlineExclamation,
  HiOutlinePhone,
  HiOutlineTag,
} from 'react-icons/hi';
import clsx from 'clsx';

import * as fontAwesome from '../../../assets/icon/font-awesome';
import { LegacyColors } from 'constants';
import './Icons.css';

const hiIcons = { HiOutlineExclamation, HiOutlinePhone, HiOutlineTag };

const Icon = ({
  name,
  onClick,
  fontSize = 20,
  style,
  color = LegacyColors.black,
  disabled,
  id,
  alt,
  ariaHidden = false,
  ariaLabel,
  tabIndex = '0',
  role,
  className,
}) => {
  const Component = fontAwesome[name] || mdIcons[name] || hiIcons[name];
  const iconColor = disabled ? 'silver' : color;
  const isStrokeIcon = Boolean(hiIcons[name]);
  return (
    <Component
      size={`${fontSize}px`}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
      tabIndex={ariaLabel ? tabIndex : -1}
      role={role}
      id={id}
      data-testid={id}
      name={name}
      alt={alt}
      className={clsx(
        'alf-icon',
        className,
        onClick && 'button',
        disabled && 'disabled',
      )}
      onClick={onClick}
      style={{
        width: `${fontSize}px`,
        height: `${fontSize}px`,
        ...(isStrokeIcon
          ? { fill: 'none', color: iconColor }
          : { fill: iconColor, color: iconColor }),
        ...style,
      }}
    />
  );
};

Icon.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  color: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  alt: PropTypes.string,
  ariaHidden: PropTypes.bool,
  ariaLabel: PropTypes.string,
  role: PropTypes.string,
  className: PropTypes.string,
};

export default Icon;
